var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header":"Add Community Event"}},[_c('community-event-form',{attrs:{"event":_vm.event,"submit":_vm.addEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }